export default __webpack_public_path__ + "static/media/ethereum.e82f118a.png";